import { Box, Grid, Input, Stack, Typography } from "@mui/material";
import { InvItem } from "./invItem";
import "./inv.css";
import { ItemDetails } from "./itemDetails";
import { useState } from "react";
import { UiControls } from "./uicontrols";

export const Inv = (itemList, quantity) => {
  if (!itemList) {
    itemList = [];
  }
  var j = itemList.itemList;

  var view = itemList.view;

  var [iteminfo, setIteminfo] = useState({
    name: "xxxxxxxxx",
    quantity: "",
    priceEach: "",
    priceTotal: "",
  });

  var [ssearch, setSsearch] = useState('');
  var [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  //FILTERING J
  if (ssearch !== '') {
    var theNew = [];
    for (var d = 0; d < j.length; d++) {
      if (j[d][0].includes(ssearch.toLowerCase())) {
        theNew.push(j[d]);
      }
    }
    j = theNew;
  }

  var hoverCallBack = function (inputs) {
    setIteminfo(inputs);
  };

  var handleSearchChange = (event) => {
    setSsearch(event.target.value);
  };

  var hoverEndCallBack = function () {
    setIteminfo({
      name: "xxxxxxxxx",
      quantity: "",
      priceEach: "",
      priceTotal: "",
    });
  };

  var [invState, setInvState] = useState('open');

  var handleExpandInv = (whatIs) => {
    console.log('inv handleExpand ' + whatIs);
    setInvState(whatIs);
  };

  var handleRefreshInv = () => {
    console.log('handleRefresh');
  };

  if (invState == 'closed') {
    return (
      <Box className="inv">
        <Box className="invTitleHolder">
          <Stack>
            <Grid container className={'spanRowT'} spacing={{ xs: 0 }}>
              <Typography textAlign={"center"} variant="h5" className={"theTitle"}>
                Inventory
              </Typography>
              <UiControls hideRefresh={true} startState={invState} expand={handleExpandInv} refresh={handleRefreshInv} />
            </Grid>
          </Stack>
        </Box>
      </Box>
    );
  }

  if (view == 0) {
    return (
      <Box className="inv" onMouseMove={(e) => setMousePos({ x: e.clientX, y: e.clientY })}>
        <Box className="invTitleHolder">
          <Stack>
            <Grid container className={'spanRowT'} spacing={{ xs: 0 }}>
              <Typography textAlign={"center"} variant="h5" className={"theTitle"}>
                Inventory
              </Typography>
              <UiControls hideRefresh={true} startState={invState} expand={handleExpandInv} refresh={handleRefreshInv} />
            </Grid>
            <Box className="financialBar">
              <span>Inv: {itemList.totals?.inv}</span>
              <span>Coins: {itemList.totals?.coins}</span>
              <span>Total: {itemList.totals?.total}</span>
            </Box>
            <Input
              type="text"
              id="inputSpyName"
              className="inputSpyName"
              defaultValue={''}
              onChange={handleSearchChange}
            />
          </Stack>
        </Box>
        <Box sx={{ height: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <Box className="invItemGrid">
            {j.map((_, index) => {
              return (
                <Box padding={"6px"} key={index}>
                  <InvItem
                    name={_[0].toString()}
                    quantity={_[1]}
                    price={_[2]}
                    hoverCallBack={hoverCallBack}
                    hoverEndCallBack={hoverEndCallBack}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
        {iteminfo.name !== "xxxxxxxxx" && (
          <Box
            className="invPopup"
            style={{ left: mousePos.x + 16, top: mousePos.y + 16 }}
          >
            <ItemDetails inputVars={iteminfo} />
          </Box>
        )}
      </Box>
    );
  } else {
    return (
      <Box className="inv" onMouseMove={(e) => setMousePos({ x: e.clientX, y: e.clientY })}>
        <Box className="invTitleHolder">
          <Stack>
            <Grid container className={'spanRowT'} spacing={{ xs: 0 }}>
              <Typography textAlign={"center"} variant="h5" className={"theTitle"}>
                Inventory
              </Typography>
              <UiControls hideRefresh={true} startState={invState} expand={handleExpandInv} refresh={handleRefreshInv} />
            </Grid>
            <Box className="financialBar">
              <span>Inv: {itemList.totals?.inv}</span>
              <span>Coins: {itemList.totals?.coins}</span>
              <span>Total: {itemList.totals?.total}</span>
            </Box>
            <Input
              type="text"
              id="inputSpyName"
              className="inputSpyName"
              defaultValue={''}
              onChange={handleSearchChange}
            />
          </Stack>
        </Box>
        <Box sx={{ height: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <Grid container className={'spanRowT'} spacing={{ xs: 0 }}>
            {j.map((_, index) => {
              return (
                <Grid xs={4} className={'spanRow'} key={index}>
                  <Box padding={"8px"}>
                    {"" + _[1] + "x " + _[0].toString() + ""}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
        {iteminfo.name !== "xxxxxxxxx" && (
          <Box
            className="invPopup"
            style={{ left: mousePos.x + 16, top: mousePos.y + 16 }}
          >
            <ItemDetails inputVars={iteminfo} />
          </Box>
        )}
      </Box>
    );
  }
};
